var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105 105",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.71,11.61H9.29A4.3,4.3,0,0,0,5,15.9V31h95V15.9A4.3,4.3,0,0,0,95.71,11.61Zm-30.24,13a3.1,3.1,0,1,1,3.09-3.09A3.09,3.09,0,0,1,65.47,24.58Zm12.29,0a3.1,3.1,0,1,1,3.09-3.09A3.1,3.1,0,0,1,77.76,24.58Zm12.28,0a3.1,3.1,0,1,1,3.09-3.09A3.09,3.09,0,0,1,90,24.58ZM5,89.1a4.3,4.3,0,0,0,4.3,4.29H95.71A4.3,4.3,0,0,0,100,89.1V36.18H5ZM44.91,62.79l-7.63-7.62a2.15,2.15,0,0,1,0-3l3-3a2.14,2.14,0,0,1,3,0L51,56.72a2.15,2.15,0,0,0,3,0l7.63-7.63a2.14,2.14,0,0,1,3,0l3,3a2.15,2.15,0,0,1,0,3l-7.63,7.62a2.15,2.15,0,0,0,0,3l7.63,7.63a2.15,2.15,0,0,1,0,3l-3,3a2.14,2.14,0,0,1-3,0L54,71.91a2.15,2.15,0,0,0-3,0l-7.63,7.62a2.14,2.14,0,0,1-3,0l-3-3a2.15,2.15,0,0,1,0-3l7.63-7.63A2.15,2.15,0,0,0,44.91,62.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTab);
export default __webpack_public_path__ + "static/media/closeTab.2acb07c276a9ed945818955be3983ada.svg";
export { ForwardRef as ReactComponent };